import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../models/cards';

@Component({
  selector: 'cards',
  templateUrl: './cards.component.html',
  standalone: false,
})
export class CardsComponent implements OnInit {
  @Input() listCards: Card[] = [];

  constructor() {}

  ngOnInit(): void {}
}
